module.exports = __webpack_public_path__ + "img/15.ae7639b2.jpg";